module.exports = __webpack_public_path__ + "img/compress-icon.d59764b1.svg";